/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Form } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { Node } from '@/client';
import { IncomingData } from '@/components/Node/IncomingData';
import { NodeViewPageCard } from '@/components/Node/NodeViewPageCard';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Col } from '@/primitives/Col';
import { Row } from '@/primitives/Row';

dayjs.extend(utc);

export type NodeHeartbeatProps = {
  data: Node | undefined;
  isPending: boolean;
};

export function NodeHeartbeats({ data, isPending }: NodeHeartbeatProps) {
  const { t } = useMimicTranslation('node');

  return (
    <NodeViewPageCard title={t('heartbeats')}>
      <Form layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <IncomingData
              label={t('last_configuration_heartbeat')}
              loading={isPending}
              text={
                data?.heartbeatStates?.config.stateTime
                  ? dayjs(data?.heartbeatStates?.config.stateTime).utc().format('DD MMM YYYY HH:mm:ss')
                  : undefined
              }
            />
          </Col>
          <Col span={12}>
            <IncomingData
              label={t('last_credentials_heartbeat')}
              loading={isPending}
              text={
                data?.heartbeatStates?.credential.stateTime
                  ? dayjs(data?.heartbeatStates?.credential.stateTime).utc().format('DD MMM YYYY HH:mm:ss')
                  : undefined
              }
            />
          </Col>
        </Row>
      </Form>
    </NodeViewPageCard>
  );
}
